// extracted by mini-css-extract-plugin
export default {"content":"style_content__GVpki","leftSide":"style_leftSide__rF3tJ","rightSide":"style_rightSide__MG4pM","type":"style_type__0jvvw"};